var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view-cell',{attrs:{"context-menu-items":_vm.contextMenuItems}},[_c('h3',{staticClass:"font-bold pb-2"},[_vm._v(_vm._s(_vm.item.name))]),_c('p',{staticClass:"text-sm"},[_vm._v(_vm._s(_vm.item.vendorName))])])}
var staticRenderFns = []

export { render, staticRenderFns }